import * as React from "react";
import type { SVGProps } from "react";
const SvgSparkPrimavera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#spark-primavera_svg__a)">
      <path
        fill="currentColor"
        d="M16.26 3.3a9.1 9.1 0 0 0-5-1.3c-1.57 0-3.58 0-4.48.11A1.71 1.71 0 0 0 5.1 3.39a60 60 0 0 0 0 6.16c0 4 0 7.45-.06 11.11 0 .82.58 1.34 1.63 1.34s1.69-.4 1.69-1.46C8.36 18.48 8.3 7 8.3 4.9h2.8a6.2 6.2 0 0 1 2.93.55 3 3 0 0 1 1.63 2.94 3.57 3.57 0 0 1-2.5 3.52c-.744.148-1.502.215-2.26.2h-.24c-.72 0-1.21.51-1.21 1.43S9.81 15 10.74 15a27 27 0 0 0 3.32-.26 6.48 6.48 0 0 0 4.78-6.2 5.8 5.8 0 0 0-2.58-5.24"
      />
    </g>
    <defs>
      <clipPath id="spark-primavera_svg__a">
        <path fill="#fff" d="M5 2h13.83v20H5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSparkPrimavera;
